import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Skill, SkillsCollection } from '@dges/modules/portfolio/domain';
import {
  Firestore,
  CollectionReference,
  DocumentReference,
  collection,
  collectionData,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class SkillsCollectionService implements SkillsCollection {
  private firestore = inject(Firestore);

  private skillsCollection = collection(
    this.firestore,
    'skills',
  ) as CollectionReference<Skill>;

  public getSkills(): Observable<Skill[]> {
    return collectionData(this.skillsCollection, {
      idField: 'id',
    }) as Observable<Skill[]>;
  }

  public addSkill(skill: Skill): Promise<DocumentReference<Skill>> {
    return addDoc(this.skillsCollection, skill);
  }

  public editSkill(skill: Skill): Promise<void> {
    return updateDoc(doc(this.skillsCollection, String(skill.id)), {
      ...skill,
    });
  }

  public deleteSkill(skill: Skill): Promise<void> {
    return deleteDoc(doc(this.skillsCollection, String(skill.id)));
  }
}
